import { render, staticRenderFns } from "./StakeholderDialog.vue?vue&type=template&id=2951d544&scoped=true&"
import script from "./StakeholderDialog.vue?vue&type=script&lang=js&"
export * from "./StakeholderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951d544",
  null
  
)

export default component.exports